<template>
  <a-card>
    <span slot="title">BKM List</span>
    <!-- <a-card> -->
    <div style="display: none">
      <a-select
        placeholder="Ex: Need Process ... "
        v-model="activetab"
        :disabled="true"
        @change="moreSearch"
        class="width-full"
        initialValue="process"
        allowClear
      >
        <a-select-option value="process">Need Process</a-select-option>
        <a-select-option value="release">BKM Release</a-select-option>
      </a-select>
    </div>
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
        <a-input-search v-model="search" placeholder="Quick Search" />
      </a-col>
      <a-col
        :class="getScreen ? 'margin-top' : ''"
        :xs="{ span: 24 }"
        :lg="{ span: 3 }"
      >
        <a-button
          block
          :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
          @click="handleshowMore"
          >{{ advancedsearch == "display:none" ? "More" : "Less" }}</a-button
        >
      </a-col>
    </a-row>
    <a-row :style="advancedsearch" :gutter="16" class="margin-top">
      <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
        <div class="m-form-item-wrapper">
          <label>Transaction Date</label>
          <a-range-picker
            :placeholder="['Start Date', 'End Date']"
            v-model="transactionDt"
            :format="getDefaultDateFormat"
            allowClear
          />
        </div>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
        <div v-if="activetab == 'process'" class="m-form-item-wrapper">
          <label>Transaction Type</label>
          <a-select
            placeholder="Ex: PI ... "
            v-model="typetransaction"
            class="width-full"
            initialValue="all"
          >
            <a-select-option value="all">All transaction</a-select-option>
            <a-select-option v-for="item in listTrans" :key="item">{{
              item
            }}</a-select-option>
          </a-select>
        </div>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }"> &nbsp; </a-col>
    </a-row>
    <!-- </a-card> -->

    <a-tabs class="custom-tabs" :activeKey="activetab" @change="handleTab">
      <a-tab-pane style="margin: auto" key="process" v-if="!isAkuntansi">
        <template slot="tab" :visible="false">
          <span>Need Process</span>
          <a-badge
            class="m-badge m-badge-small"
            :count="list_process.length"
            :numberStyle="{ backgroundColor: 'red' }"
            v-if="list_process.length > 0"
          >
          </a-badge>
        </template>
        <div class="loading" v-if="loading.process">
          <a-spin :spinning="loading.process" tip="Loading..."></a-spin>
        </div>
        <a-table
          v-else
          rowKey="key"
          id="process"
          :columns="column_process"
          :dataSource="list_process"
          :pagination="pagination"
          size="small"
          bordered
          :scroll="{ x: 1000, y: 500 }"
        >
          <template slot="title">
            <div class="title-table">
              <h3 class="margin-remove">Process List</h3>
              <span>Selected {{ selectedData.length }}</span>
            </div>
          </template>
          <a
            slot="no"
            slot-scope="item"
            @click="handleLinkManifest(item.jenis, item.id_manifest)"
            >{{ item.no }}</a
          >
          <span slot="value" slot-scope="amount">
            <CurrencyJustified
              v-if="amount.value"
              :currencyValue="amount.currency"
              :valueNumber="amount.value"
            />
            <div v-else style="text-align: center; width: 100%">-</div>
          </span>
          <span slot="create_by" slot-scope="item">
            <span v-if="item.tlc_updated">
              {{ item.pembuat }} /
              {{
                item.tgl_transaksi
                  ? moment(
                      item.tgl_transaksi,
                      getDateTimeStandartFormat
                    ).format(getDefaultDateFormat)
                  : "-"
              }}
            </span>
            <span v-else> - </span>
          </span>
          <span slot="centang" slot-scope="item">
            <a-checkbox
              :default-checked="item.dana_sts"
              :key="item.key"
              @change="changeActionItem(item)"
            />
          </span>
        </a-table>
      </a-tab-pane>
      <a-tab-pane tab="BKM List" key="release">
        <div class="loading" v-if="loading.release">
          <a-spin :spinning="loading.release" tip="Loading..."></a-spin>
        </div>
        <a-table
          v-else
          rowKey="key"
          :columns="column_release"
          :dataSource="list_release"
          id="id_pp1"
          size="small"
          :pagination="pagination"
          bordered
          :scroll="{ x: 1000 }"
        >
          <template slot="title">
            <h4 slot="title">Release list</h4>
          </template>
          <a
            slot="no"
            slot-scope="item"
            @click="handleLink(item.jenis, item.id)"
            >{{ item.no }}</a
          >
          <div slot="deskripsi" slot-scope="text">
            <span style="white-space: pre-line">{{ text }}</span>
          </div>
          <span slot="value" slot-scope="amount">
            <CurrencyJustified
              v-if="amount.value"
              :currencyValue="amount.currency"
              :valueNumber="amount.value"
            />
            <div v-else style="text-align: center; width: 100%">-</div>
          </span>
          <span slot="update_by" slot-scope="item">
            <span v-if="item.pembuat">
              {{ item.pembuat }} /
              {{
                item.tgl_transaksi
                  ? moment(
                      item.tgl_transaksi,
                      getDateTimeStandartFormat
                    ).format(getDefaultDateFormat)
                  : "-"
              }}
            </span>
            <span v-else> - </span>
          </span>
          <span slot="action" slot-scope="item">
            <a-button
              :type="item.need_upload == '0' ? 'default' : 'primary'"
              @click="handleLink(item.id)"
              :key="item.key"
            >
              {{ item.need_upload == "0" ? "Manifest" : "Upload BKM" }}
            </a-button>
          </span>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <div v-if="activetab == 'process'" class="float-right">
          <a-button type="primary" @click="handleGenerate()">
            Generate
          </a-button>
        </div>
      </a-col>
    </a-row>
    <a-modal v-model="editModal" :maskClosable="false" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;Generate BKM </span>
      <a-form :form="modalForm">
        <a-form-item label="Bank Account">
          <a-select
            placeholder="Select Bank Account"
            v-decorator="['bank_account_id', { rules: [{ required: true }] }]"
            :disabled="gen_bank_disabled"
            @change="changebankModal"
          >
            <a-select-option
              v-for="item in list_bank_av"
              :key="item.bank_account_id"
              >[{{ item.bank_account_id }}] {{ item.nama_bank }} ({{
                item.kode_rekening
              }})</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Transfer Date">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="[
              'transfer_date',
              {
                rules: [{ required: true }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          v-if="
            editModal &&
            selectedData[0].jenis == 'am' &&
            selectedData[0].currency !== selectedData[0].currency_to
          "
          label="Value BKM"
        >
          <a-input-number
            v-decorator="[
              'value_bkm',
              {
                initialValue: 0,
                rules: [{ required: false }],
              },
            ]"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) =>
                `${symbolCurrencyES6(
                  selectedData[0].currency_to,
                  0
                )} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(curr_to_replace, '')"
          ></a-input-number>
        </a-form-item>
        {{ modalForm.getFieldValue.value_bkm }}
        <div class="m-price-total">
          <div class="m-display-flex space-between align-middle">
            <h4>Value Transaction</h4>
            <h3>{{ gen_select_value }}</h3>
          </div>
        </div>
        <a-button
          block
          class="margin-top"
          type="primary"
          :loading="previewLoad"
          @click="previewBKMlist"
          >Preview List BKM</a-button
        >
        <a-button
          block
          class="margin-top"
          type="danger"
          :loading="loading.generate"
          @click="submitGenerate"
          html-type="submit"
          >Submit</a-button
        >
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import shortingArray from "@/mixins/MultishortArray";
import _ from "lodash";
export default {
  name: "BKM",
  props: ["page_type"],
  mixins: [CurrencyFormat, shortingArray],
  data() {
    return {
      activetab: "process",
      typetransaction: "all",
      typepage: "",
      list_release: [],
      list_process: [],
      selectedData: [],
      loading: {
        release: false,
        process: false,
        generate: false,
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 20,
        size: "small",
      },
      list_bank: [],
      list_bank_av: [],
      basedListprocess: [],
      basedListrelease: [],
      transactionDt: [],
      search: undefined,
      editModal: false,
      gen_selected: [],
      previewLoad: false,
      advancedsearch: "display:none",
      gen_select_value: 0,
      gen_select_valueExchange: 0,
      gen_bank_disabled: false,
      gen_curr: "IDR",
      disabledCurrrate: false,
      defaulcurrency_bank: "IDR",
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
      "getTypePage",
    ]),
    moreSearch() {
      let tempData =
        this.activetab == "process"
          ? this.basedListprocess
          : this.basedListrelease;
      // if (tempData.length > 0) {
      if (this.search) {
        tempData = tempData.filter(
          (obj) =>
            (obj.no &&
              obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.deskripsi &&
              obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
            (obj.tgl_transaksi &&
              this.moment(obj.tgl_transaksi)
                .format(this.getDefaultDateFormat)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.value &&
              this.formatCurrency(obj.currency, obj.value)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.tlc_updated &&
              this.formatCurrency(obj.currency, obj.tlc_updated)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
        );
        this.intoList(this.activetab, tempData);
      }

      if (this.typetransaction && this.typetransaction !== "all") {
        if (this.activetab === "process") {
          tempData = tempData.filter(
            (obj) =>
              obj.label_jenis_transaksi &&
              obj.label_jenis_transaksi == this.typetransaction
          );
        }
      }

      if (this.transactionDt && this.transactionDt.length > 0) {
        let startDt = moment(this.transactionDt[0]).format("YYYY-MM-DD");
        let endDt = moment(this.transactionDt[1]).format("YYYY-MM-DD");

        tempData = tempData.filter(
          (obj) =>
            obj.tgl_transaksi &&
            moment(obj.tgl_transaksi).format("YYYY-MM-DD") >= startDt &&
            moment(obj.tgl_transaksi).format("YYYY-MM-DD") <= endDt
        );
      }
      // }
      this.intoList(this.activetab, tempData);
      return true;
    },
    column_process() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: 40,
          align: "center",
        },
        {
          title: "No",
          width: 250,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Transaction Type / TLC",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 200,
        },
        {
          title: "Bank Account To",
          key: "bank",
          dataIndex: "bank",
          width: 250,
        },
        {
          title: "Value",
          key: "value",
          width: 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Updated By",
          key: "create_by",
          width: 100,
          align: "center",
          scopedSlots: { customRender: "create_by" },
        },
        {
          title: "Generate",
          key: "centang",
          width: 80,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "centang" },
        },
      ];
      return kolom;
    },
    column_release() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: 20,
          align: "center",
        },
        {
          title: "No",
          width: 70,
          dataIndex: "no",
          key: "no",
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          scopedSlots: { customRender: "deskripsi" },
          width: 120,
        },

        {
          title: "Value",
          key: "value",
          width: 75,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Updated By",
          key: "create_by",
          width: 65,
          align: "center",
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Action",
          width: 60,
          align: "center",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ];
      return kolom;
    },
    column_preview() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: 20,
          align: "center",
        },
        {
          title: "No",
          width: 70,
          dataIndex: "no",
          key: "no",
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 150,
        },

        {
          title: "Value",
          key: "value",
          width: 75,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Transaction Type",
          key: "transactiontype",
          dataIndex: "jenis",
          width: 65,
          align: "center",
        },
      ];
      return kolom;
    },
    curr_to_replace() {
      return eval(
        "/\\" +
          this.symbolCurrencyES6(this.selectedData[0].currency_to, 1) +
          "\\s?|(,*)/g"
      );
    },
    gen_currReplace() {
      return eval(
        "/\\" + this.symbolCurrencyES6(this.gen_curr, 1) + "\\s?|(,*)/g"
      );
    },
    listTrans() {
      return _.uniq(_.map(this.basedListprocess, "label_jenis_transaksi"));
    },
    isAkuntansi(){
      return localStorage.getItem("nvpn") === "/akuntansiKeuangan" || localStorage.getItem("nvpn") === "/FinancialControl"
    }
  },
  mounted() {
    if(this.isAkuntansi){
      this.activetab= "release"
    }
    this.fetchData();
  },
  beforeCreate() {
    this.modalForm = this.$form.createForm(this);
  },
  methods: {
    moment,
    fetchData() {
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
      }
      this.typepage = this.$route.meta.page_type;
      const release = axios({
        method: "get",
        url: this.$serviceUrl + "bkm",
        params: {
          tab: "bkm list",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        return err;
      });

      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "bkm",
        params: {
          tab: "need process",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        this.loading.release = false;
        this.loading.process = false;
        return err;
      });

      const bank = axios({
        method: "get",
        url: this.$serviceUrl + "bkm/bank",
        params: {},
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.loading.release = false;
        this.loading.process = false;
      });

      return new Promise((resolve, reject) => {
        axios
          .all([
            release.catch((err) => {
              console.log(err);
              return null;
            }),
            proses.catch((err) => {
              console.log(err);
              return null;
            }),
            bank.catch((err) => {
              console.log(err);
              return null;
            }),
          ])
          .then((response) => {
            this.list_release = response[0] ? response[0].data.data : [];
            this.list_process = response[1] ? response[1].data.data : [];
            this.list_bank = response[2] ? response[2].data.data : [];
            if (this.list_process.length > 0) {
              for (let index = 0; index < this.list_process.length; index++) {
                let col = [
                  {
                    ...this.list_process[index],
                    number: index + 1,
                    key: index + 1,
                    dana_sts: false,
                  },
                ];
                this.list_process[index] = col[0];
              }
            }
            if (this.list_release.length > 0) {
              for (let index = 0; index < this.list_release.length; index++) {
                let col = [
                  {
                    ...this.list_release[index],
                    number: index + 1,
                    key: index + 1,
                  },
                ];
                this.list_release[index] = col[0];
              }
            }
            this.basedListprocess = this.list_process;
            this.basedListrelease = this.list_release;
            this.loading.release = false;
            this.loading.process = false;
            this.selectedData = [];
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    intoList(type, value) {
      if (type == "process") {
        if (value.length > 0) {
          value = this.ArrshortMultiCol(value, {
            dana_sts: "desc",
            key: "asc",
          });
          for (let index = 0; index < value.length; index++) {
            value[index].number = index + 1;
          }
        }
        this.list_process = value;
      } else {
        this.list_release = value;
      }
    },
    handleTab(val) {
      this.activetab = val;
      // console.log("this.activetab",this.activetab)
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
        this.transactionDt = undefined;
        this.typetransaction = "all";
      }
      this.fetchData();
    },
    handleLink(id_) {
      this.$router.push({ name: "bkmManifestKeu", params: { id: id_ } });
    },
    reverseCheckbox() {
      this.loading.process = true;
      this.list_process = [];
      let xval = this.search;
      this.search = "";
      setTimeout(
        function () {
          this.list_process = this.basedListprocess;
          this.search = xval;
          this.moreSearch;
          this.loading.process = false;
        }.bind(this),
        100
      );
    },
    changeActionItem(item) {
      let source = this.selectedData;
      if (source.length == 0) {
        const data = { ...item, dana_sts: !item.dana_sts };
        source.push(data);
        this.list_process.forEach((res) => {
          if (res.id == data.id) {
            res.dana_sts = !res.dana_sts;
          }
        });
      } else {
        const index = source.findIndex((data) => data.id === item.id);
        let jenisLain;
        if (item.jenis === "am") {
          jenisLain = source.find((data) => data.jenis !== "am");
        }

        if (jenisLain) {
          this.displayMessageValue(
            "error-other",
            "Please select another transaction type!"
          );
          this.reverseCheckbox();
          return;
        }

        if (index >= 0) {
          source.splice(index, 1);
          this.list_process.forEach((res) => {
            if (res.id == item.id) {
              res.dana_sts = !res.dana_sts;
            }
          });
        } else {
          let condition = {
            bank: false,
            currency: false,
            am: false,
          };
          this.selectedData.forEach((data) => {
            if (data.key !== item.key && data.jenis == "am") {
              condition.am = true;
            } else if (data.currency !== item.currency) {
              condition.currency = true;
            } else if (
              item.bank_account_id !== null &&
              data.bank_account_id !== null &&
              data.bank_account_id !== item.bank_account_id
            ) {
              condition.bank = true;
            }
          });

          if (condition.bank) {
            this.displayMessageValue(
              "error-other",
              "Bank Account to are not same!"
            );
            this.reverseCheckbox();
          }

          if (condition.currency) {
            this.displayMessageValue(
              "error-other",
              "Value Currency are not same!"
            );
            this.reverseCheckbox();
          }

          if (condition.am) {
            this.displayMessageValue(
              "error-other",
              "Only 1 overbooking can generate!"
            );
            this.reverseCheckbox();
          }

          if (!condition.bank && !condition.currency && !condition.am) {
            const data = { ...item, dana_sts: !item.dana_sts };
            this.list_process.forEach((res) => {
              if (res.id == data.id) {
                res.dana_sts = !res.dana_sts;
              }
            });

            source.push(data);
          }
        }
      }

      this.list_process = this.ArrshortMultiCol(this.list_process, {
        dana_sts: "desc",
        key: "asc",
      });

      this.selectedData = source;
    },
    handleGenerate() {
      this.gen_selected = this.basedListprocess.filter(
        (item) => item.dana_sts == true
      );

      this.gen_selected = this.ArrshortMultiCol(this.gen_selected, {
        bank_account_id: "asc",
      });

      const bank = this.gen_selected.find(
        (item) => item.bank_account_id !== null
      );

      if (this.gen_selected.length == 0) {
        this.displayMessageValue(
          "error-other",
          "Please select data to generate!"
        );
      } else {
        this.editModal = true;
        this.modalForm.resetFields();

        this.gen_bank_disabled =
          bank == "-" || bank == undefined ? false : true;
        let ttl = 0;
        this.gen_selected.forEach((item) => {
          ttl += parseFloat(item.value);
        });

        this.list_bank_av = _.filter(this.list_bank, {
          currency:
            this.gen_selected[0].currency_bank == null
              ? this.gen_selected[0].currency_to
              : this.gen_selected[0].currency,
        });

        this.defaulcurrency_bank = this.gen_selected[0].currency;

        this.gen_select_value = this.formatCurrency(
          this.defaulcurrency_bank,
          ttl
        );
        this.gen_select_valueExchange = this.formatCurrency(
          this.defaulcurrency_bank,
          0
        );

        this.gen_curr = this.gen_selected[0].currency_bank
          ? this.gen_selected[0].currency_bank
          : "IDR";

        this.$nextTick(function () {
          this.modalForm.setFieldsValue({
            bank_account_id:
              bank.bank == "-" ? undefined : bank.bank_account_id,
          });
        });
      }
    },
    previewBKMlist() {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.previewLoad = true;

        let $dbank = _.filter(this.list_bank, {
          bank_account_id: values.bank_account_id,
        });
        let longDesc = "";
        let totalval = 0;
        this.gen_selected.forEach((item) => {
          longDesc += (longDesc == "" ? "" : "\n") + item.long_description + (item.jenis=='lk_um_pp' || item.jenis=='lk_um_pd' ? "" : " dengan nilai " +this.formatCurrencyCode(item.currency,item.value));
          totalval += parseFloat(item.value);
        });
        let postData = new FormData();
        postData.append("tgl_bkm", moment().format("DD MMMM YYYY"));
        postData.append("no_bkm", "-");
        postData.append("nama_bank", $dbank[0].nama_bank);
        postData.append("kode_rekening", $dbank[0].kode_rekening);
        postData.append(
          "value",
          this.gen_selected[0].currency_bank == "IDR"
            ? totalval * (values.value ? values.value : 1)
            : totalval / (values.value ? values.value : 1)
        );
        postData.append("currency", this.defaulcurrency_bank);
        postData.append("currency_to", this.selectedData[0].currency_to);
        postData.append("description", longDesc);
        postData.append("transfer_date", this.moment(values.transfer_date).format(this.getStandartFormatDate));
        postData.append(
          "value_bkm",
          this.selectedData[0].jenis == "am" ? values.value_bkm : 0
        );
        postData.append("jenis", this.selectedData[0].jenis);

        axios({
          method: "post",
          url: this.$serviceUrl + "bkm/preview_bkm",
          data: postData,
          responseType: "blob",
          processData: false,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            this.previewLoad = false;
            let blob = new Blob([response.data], { type: "application/pdf" }),
              url = window.URL.createObjectURL(blob);
            window.open(url, "_blank");
          })
          .catch((err) => {
            if (err.response && err.response.status === 404) {
              this.displayMessage("404");
            } else if (err.response) {
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            }
            this.previewLoad = false;
          });
      });
    },
    submitGenerate() {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (
          !(values.value_bkm > 0) &&
          this.selectedData[0].jenis == "am" &&
          this.selectedData[0].currency !== this.selectedData[0].currency_to
        ) {
          this.displayMessageValue(
            "error-other",
            "Value bkm must be greater then 0!"
          );
          return;
        }

        this.loading.generate = true;
        let selected_item = [];
        let long_description = "";
        this.gen_selected.forEach((item) => {
          selected_item.push({
            jenis: item.jenis,
            tgl_transaksi: item.tgl_transaksi,
            id: item.id,
            no: item.no,
            deskripsi: item.deskripsi,
            currency: this.defaulcurrency_bank,
            kurs: values.value,
            value: item.value,
            currency_from: item.currency,
          });

          long_description +=
            (long_description == "" ? "" : "\n") + item.long_description + (item.jenis=='lk_um_pp' || item.jenis=='lk_um_pd' ? "" : " dengan nilai " +this.formatCurrencyCode(item.currency,item.value));
        });

        axios({
          method: "post",
          url: this.$serviceUrl + "bkm/submit_bkm",
          processData: false,
          data: {
            tlc: this.getAuth.username,
            long_description: long_description,
            bank_account_id: values.bank_account_id,
            selected_item: selected_item,
            currency_to: this.selectedData[0].currency_to,
            transfer_date: this.moment(values.transfer_date).format(this.getStandartFormatDate), 
            value_bkm:
              this.selectedData[0].jenis == "am" ? values.value_bkm : 0,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessageValue("success-other", response.data.message);
            this.loading.generate = false;
            this.editModal = false;
            this.resetFilter();
            this.fetchData();
            this.activetab = "release";
          })
          .catch((err) => {
            this.loading.generate = false;
            let responses = Object.assign({}, err.response);
            this.displayMessageValue("error", responses);
          });
      });
    },
    handleLinkManifest(jenis, id_) {
      let manifest = "";
      if (jenis == "ar_s") {
        manifest = "account-receive-manifest";
      } else if (jenis == "ar_g") {
        manifest = "account-receive-manifest";
      } else if (jenis == "oi") {
        manifest = "OtherIncomeManifestKeu";
      } else if (jenis == "financing_fk") {
        manifest = "penarikan-financing-manifest";
      } else if (jenis == "financing_fp") {
        manifest = "financing-manifest";
      } else if (jenis == "lk_um_pp") {
        manifest = "lapUmppManifest";
      } else if (jenis == "lk_um_pd") {
        manifest = "manifestLaporanUmpd";
      } else if (jenis == "am") {
        manifest = "AccountMutationManifestKeu";
      } else if (jenis == "bidbond_request") {
        manifest = "bidBondRequest-manifestKeu";
      } else if (jenis == "bidbond") {
        manifest = "bidBond-manifestKeu";
      } else if (jenis == "pembayaran_piutang") {
        manifest = "pembayaranpiutang-manifest-keu";
      } else if (jenis == "refund_payment") {
        manifest = "RefundPaymentManifestKeu";
      } else if (jenis == "lap_bailout") {
        manifest = "bailoutfundreportManifest";
      } else {
        manifest = "Manifest";
      }

      if (jenis == "ar_s" || jenis == "ar_g") {
        this.$router.push({
          name: manifest,
          params: {
            id: id_,
            tab: "release",
            jns: jenis == "ar_s" ? "Penerimaan_Kontrak" : "Piutang_lain_lain",
          },
        });
      } else {
        this.$router.push({ name: manifest, params: { id: id_ } });
      }
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Value must greater than zero!");
    },
    changevalue(vals) {
      let hasil = 0;
      this.gen_selected.forEach((item) => {
        hasil = hasil + parseFloat(item.value);
      });
      if (this.gen_selected[0].currency_bank == "IDR") {
        this.gen_select_valueExchange = this.formatCurrency(
          this.defaulcurrency_bank,
          hasil * vals
        );
      } else {
        this.gen_select_valueExchange = this.formatCurrency(
          this.defaulcurrency_bank,
          hasil / vals
        );
      }
    },
    changebankModal(item) {
      let $dbank = _.filter(this.list_bank, {
        bank_account_id: item,
      });
      this.gen_curr = $dbank[0].currency;
      this.defaulcurrency_bank = $dbank[0].currency;
      if (this.gen_selected[0].currency == this.gen_curr) {
        this.disabledCurrrate = true;
      } else {
        this.disabledCurrrate = false;
      }

      let hasil = 0;
      this.gen_selected.forEach((item) => {
        hasil = hasil + parseFloat(item.value);
      });

      this.gen_select_valueExchange = this.formatCurrency(
        this.defaulcurrency_bank,
        hasil
      );
    },
    resetFilter() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.typetransaction = undefined;
    },
  },
};
</script>

<style lang="less" scoped>
.title-table {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.float-right {
  padding: @padding;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.ant-table-thead > tr > th {
  text-align: center;
}
</style>
